import { CONSENT_MODES } from '../constants';
import createDidomiConsent from './didomi';

// Each strategy answers two questions: may we store now (`hasConsent`, a
// promise), and tell me when that changes (`subscribe`, returning an
// unsubscribe). Adding a consent platform means adding a strategy here.
const noop = () => {};

const fixed = granted => ({
  hasConsent: () => Promise.resolve(granted),
  subscribe: () => noop
});

// A site supplied check, for requirements none of the built in modes cover:
//   consent: { mode: 'custom', hasConsent: () => boolean | Promise<boolean>,
//              subscribe: onChange => unsubscribe }
// A check that throws or rejects counts as no consent.
const createCustomConsent = ({ hasConsent, subscribe } = {}) => {
  if (typeof hasConsent !== 'function') return fixed(false);

  return {
    hasConsent: () =>
      Promise.resolve()
        .then(() => hasConsent())
        .then(result => result === true)
        .catch(() => false),
    subscribe: onChange => {
      if (typeof subscribe !== 'function') return noop;
      const unsubscribe = subscribe(granted => onChange(granted === true));
      return typeof unsubscribe === 'function' ? unsubscribe : noop;
    }
  };
};

/**
 * Builds the consent strategy for the configured mode. An unknown mode never
 * grants, so a misconfiguration fails closed.
 */
export default function createConsent(consent = {}) {
  const { mode, ...options } = consent;

  switch (mode) {
    case CONSENT_MODES.ASSUMED:
      return fixed(true);
    case CONSENT_MODES.DIDOMI:
      return createDidomiConsent(options);
    case CONSENT_MODES.CUSTOM:
      return createCustomConsent(options);
    case CONSENT_MODES.DISABLED:
    default:
      return fixed(false);
  }
}
